export default __webpack_public_path__ + "static/Plots0034-dad37b78ba6166656a893fc6092841fa.jpg";